import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CxFormsModule } from '@forms';
import { ApiComingSoonComponent } from './api-coming-soon.component';
import { ApiDocumentationComponent } from './api-documentation.component';
import { ApiFaqComponent } from './api-faq.component';
import { ApiComponent } from './api.component';
import { MarkdownModule } from 'ngx-markdown';
import { AppContainerDocumentationComponent } from './app-container-documentation.component';

@NgModule({
    imports: [
        CommonModule,
        CxFormsModule,
        MarkdownModule
    ],
    declarations: [
        ApiDocumentationComponent,
        ApiComingSoonComponent,
        ApiComponent,
        ApiFaqComponent,
        AppContainerDocumentationComponent
    ],
    exports: [
        ApiDocumentationComponent,
        ApiComingSoonComponent,
        ApiComponent,
        ApiFaqComponent,
        AppContainerDocumentationComponent
    ]
})
export class ApiDocumentationModule { }

export {
    ApiDocumentationComponent,
    ApiComingSoonComponent,
    ApiComponent,
    ApiFaqComponent,
    AppContainerDocumentationComponent
}
